'use client';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import useKeypress from '@wt/shared/hooks/useKeyPress';
import { useEffect, useRef } from 'react';

const DualDropOnePinModal = ({
  closeModal,
  handleClickConfirm,
}: {
  closeModal: () => void;
  handleClickConfirm: () => void;
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useKeypress('Escape', () => {
    closeModal();
  });

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !event.composedPath().includes(modalRef.current)
      ) {
        closeModal();
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [modalRef]);

  return (
    <div className="modal pointer-events-auto visible flex items-center justify-center opacity-100">
      <div
        ref={modalRef}
        className="modal-box visible fixed z-50 w-full max-w-md bg-white"
      >
        <div className="flex flex-col gap-4">
          <div className="flex w-full flex-row items-center justify-between">
            <div className="flex flex-row items-center">
              <div className="mr-3 flex size-7 items-center justify-center rounded-full bg-[#FFF6E5] md:size-11">
                <WarningAmberRoundedIcon
                  htmlColor="#FFA800"
                  className="text-lg md:text-3xl"
                />
              </div>
              <div className="text-base text-[#322E38] md:text-2xl">
                You only placed 1 pin
              </div>
            </div>
            <div className="cursor-pointer" onClick={closeModal}>
              <CloseRoundedIcon
                htmlColor="#4B4554"
                className="text-lg md:text-3xl"
              />
            </div>
          </div>
          <span className="text-sm text-[#1A0F2A] md:text-base">
            You chose the ‘Dual Drop’ hint, which allows you to place two pins
            on the map to increase you chances of guessing the location.
            However, you haven’t placed the second pin on the map.
          </span>
          <span className="text-sm text-[#1A0F2A] md:text-base">
            Are you sure you want to proceed without placing your second pin?
          </span>
          <div className="flex w-full flex-row justify-center gap-6">
            <button
              type="button"
              onClick={closeModal}
              className="btn min-h-[33px] shrink border border-[#645C70] bg-white px-5 text-sm font-normal text-[#230351] hover:bg-[#F6F0FE] md:min-h-[40px] md:px-8 md:text-base"
            >
              No, place the second pin
            </button>
            <button
              type="button"
              onClick={handleClickConfirm}
              className="btn btn-primary min-h-[33px] shrink px-5 text-sm font-normal text-white md:min-h-[40px] md:px-8 md:text-base"
            >
              Yes, confirm guess
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DualDropOnePinModal;
